export const PROVIDER_CLEAR = 'PROVIDER_CLEAR';
export const PROVIDER_FETCH = 'PROVIDER_FETCH';
export const PROVIDER_SELECTED = 'PROVIDER_SELECTED';

export default {
    clear: PROVIDER_CLEAR,
    fetch: PROVIDER_FETCH,
    selected: PROVIDER_SELECTED
};
